import React from "react";
import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { RootStackParamList } from "../navigator";
import { MessagesModal } from "../Components";

type Props = NativeStackScreenProps<RootStackParamList, "Messages">;

const MessagesScreen: React.FC<Props> = ({ navigation }) => {
  return (
    <MessagesModal
      onClose={() => {
        if (navigation.canGoBack()) {
          navigation.goBack();
        } else {
          navigation.navigate("Main");
        }
      }}
    />
  );
};

export default MessagesScreen;
